import type {
  ResolveAssetsRequest,
  ResolveAssetsResponse,
} from "~/ui-rtk/api/assetsApi"

export const RESOLVE_ASSETS_BATCH_SIZE = 100

type AssetRef = ResolveAssetsRequest["assets"][number]

/**
 * Split asset refs into batches that satisfy the backend DTO contract:
 * - Drops entries with missing/empty `externalRefId` (the server rejects them
 *   via `@IsNotEmpty()` on `AssetRefDto`).
 * - Chunks into arrays of at most `RESOLVE_ASSETS_BATCH_SIZE` (the server
 *   caps the request at 100 via `@ArrayMaxSize(100)` on `ResolveAssetsDto`).
 *
 * Callers iterate the batches, resolve each, and merge the responses via
 * `mergeResolveAssetsResponses`.
 */
export function buildResolveAssetsBatches(refs: AssetRef[]): AssetRef[][] {
  const valid = refs.filter(ref => Boolean(ref.externalRefId))
  const batches: AssetRef[][] = []
  for (let i = 0; i < valid.length; i += RESOLVE_ASSETS_BATCH_SIZE) {
    batches.push(valid.slice(i, i + RESOLVE_ASSETS_BATCH_SIZE))
  }
  return batches
}

export function mergeResolveAssetsResponses(
  responses: ResolveAssetsResponse[],
): ResolveAssetsResponse {
  const merged: ResolveAssetsResponse = { results: {}, errors: {} }
  for (const response of responses) {
    Object.assign(merged.results, response.results)
    Object.assign(merged.errors, response.errors)
  }
  return merged
}
